<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.deposit.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="my-account">
          <div class="bank-detail">
            <div class="note">
              {{ $t('modals.deposit.noteOneTxt') }} <br />
              <span>{{ $t('modals.deposit.noteTwoTxt') }}</span>
            </div>
            <div class="bank-name-th">
              {{ account.bank ? account.bank.nameTH : '' }}
            </div>
            <div class="bank-name-en">
              {{ account.bank ? account.bank.nameEN : '' }}
            </div>
            <div class="account-name m-t-10">
              {{
                account.bankAccountName
                  ? account.bankAccountName.toUpperCase()
                  : ''
              }}
            </div>
            <div class="account-no">
              {{ account.bankAccountNo | bankAccountFormat }}
              <i
                class="fas fa-copy m-l-10"
                v-clipboard:copy="account.bankAccountNo"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              ></i>
            </div>
          </div>
        </div>
        <div v-if="bankAccounts.length > 0">
          <div class="section-subtitle m-t-15 m-b-5">
            {{ $t('modals.deposit.bank') }}
          </div>
          <div v-for="(depositAccount, index) in bankAccounts" :key="index">
            <div v-if="!isManual">
              <div v-if="depositAccount.bankCode === 'SCB'">
                <scb :depositAccount="depositAccount"></scb>
              </div>
              <div
                v-if="
                  depositAccount.bankCode === 'KBANK' &&
                    depositAccount.mode === 'AUTO'
                "
              >
                <kbank-auto
                  :depositAccount="depositAccount"
                  :account="account"
                ></kbank-auto>
              </div>
              <div v-if="depositAccount.bankCode === 'GSB'">
                <gsb :depositAccount="depositAccount"></gsb>
              </div>
              <div v-if="depositAccount.bankCode === 'BCEL'">
                <bcel
                  :depositAccount="depositAccount"
                  :account="account"
                ></bcel>
              </div>
            </div>
            <div v-else>
              <other :depositAccount="depositAccount"></other>
            </div>
          </div>
        </div>
        <div v-if="qrcodeAccounts.length > 0">
          <div class="section-subtitle m-t-15 m-b-5">
            {{ $t('modals.deposit.qrcode') }}
          </div>
          <div v-for="(depositAccount, index) in qrcodeAccounts" :key="index">
            <div v-if="!isManual">
              <div
                v-if="
                  depositAccount.bankCode === 'KBANK' &&
                    depositAccount.mode !== 'AUTO'
                "
              >
                <kbank-qrcode
                  :depositAccount="depositAccount"
                  :refreshQrcode="refreshQrcode"
                  @clearRefreshQrcode="clearRefreshQrcode"
                  @updateRefreshQrcodeExcept="updateRefreshQrcodeExcept"
                  @closeModal="closeModal"
                ></kbank-qrcode>
              </div>

              <div
                v-if="
                  depositAccount.bankType === 'PAYMENT' &&
                    depositAccount.bankCode === 'WW'
                "
              >
                <payment-ww
                  :depositAccount="depositAccount"
                  :refreshQrcode="refreshQrcode"
                  @clearRefreshQrcode="clearRefreshQrcode"
                  @updateRefreshQrcodeExcept="updateRefreshQrcodeExcept"
                  @closeModal="closeModal"
                ></payment-ww>
              </div>
              <div
                v-if="
                  depositAccount.bankType === 'PAYMENT' &&
                    depositAccount.bankCode === 'PAYWELL'
                "
              >
                <payment-paywell
                  :depositAccount="depositAccount"
                  :refreshQrcode="refreshQrcode"
                  @clearRefreshQrcode="clearRefreshQrcode"
                  @updateRefreshQrcodeExcept="updateRefreshQrcodeExcept"
                  @closeModal="closeModal"
                ></payment-paywell>
              </div>
              <div
                v-if="
                  depositAccount.bankType === 'PAYMENT' &&
                    depositAccount.bankCode === 'PAYONEX'
                "
              >
                <payment-payonex
                  :depositAccount="depositAccount"
                  :refreshQrcode="refreshQrcode"
                  @clearRefreshQrcode="clearRefreshQrcode"
                  @updateRefreshQrcodeExcept="updateRefreshQrcodeExcept"
                  @closeModal="closeModal"
                ></payment-payonex>
              </div>
            </div>
            <div v-else>
              <other :depositAccount="depositAccount"></other>
            </div>
          </div>
        </div>
        <div v-if="walletAccounts.length > 0">
          <div class="section-subtitle m-t-15 m-b-5">
            {{ $t('modals.deposit.wallet') }}
          </div>
          <div v-if="walletAccounts[0].mode === 'AUTO'">
            <truewallet-auto
              :walletAccounts="walletAccounts"
              :profile="profile"
            ></truewallet-auto>
          </div>
          <div v-else>
            <truewallet-gift
              :walletAccounts="walletAccounts"
              @closeModal="closeModal"
            ></truewallet-gift>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiLookup from '@/api/lookup'

import Scb from './components/Scb'
import KbankAuto from './components/KbankAuto'
import KbankQrcode from './components/KbankQrcode'
import Gsb from './components/Gsb'
import Bcel from './components/Bcel'
import Other from './components/Other'

import PaymentWw from './components/PaymentWw'
import PaymentPaywell from './components/PaymentPaywell'
import PaymentPayonex from './components/PaymentPayonex'

import TruewalletAuto from './components/TruewalletAuto'
import TruewalletGift from './components/TruewalletGift'

export default {
  name: 'ModalDeposit',
  components: {
    Scb,
    KbankAuto,
    KbankQrcode,
    Gsb,
    Bcel,
    Other,
    PaymentWw,
    PaymentPaywell,
    PaymentPayonex,
    TruewalletAuto,
    TruewalletGift
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object
    },
    profile: {
      type: Object
    }
  },
  data() {
    return {
      bankAccounts: [],
      qrcodeAccounts: [],
      walletAccounts: [],
      url: process.env.VUE_APP_BASE_API,
      file: {},
      isManual: false,
      bankAccountName: '',
      refreshQrcode: {
        KBANK: false,
        WW: false,
        PAYWELL: false,
        PAYONEX: false
      }
    }
  },
  mounted() {
    this.lookupDeposit()
  },
  methods: {
    async lookupDeposit() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiLookup.lookupDeposit()

          this.bankAccounts = []
          this.qrcodeAccounts = []
          for (const bank of data.banks) {
            if (
              bank.bankType === 'PAYMENT' ||
              (bank.bankCode === 'KBANK' && bank.mode === 'SMS')
            ) {
              this.qrcodeAccounts.push(bank)
            } else {
              this.bankAccounts.push(bank)
            }
          }
          this.walletAccounts = data.wallets
          this.isManual = data.isManual

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    closeModal() {
      this.$emit('closeModal', null)
    },
    onCopy(e) {
      this.$buefy.toast.open({
        message: `copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    },
    updateRefreshQrcodeExcept(bankCode) {
      for (const [key] of Object.entries(this.refreshQrcode)) {
        if (key !== bankCode) {
          this.refreshQrcode[key] = true
        }
      }
    },
    clearRefreshQrcode(bankCode) {
      this.refreshQrcode[bankCode] = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .account {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  padding: 15px;
  border-radius: 10px;
  color: white;
  margin: 10px 0;

  &.black {
    border: 1px solid #222222;
    color: #222222;
  }

  .order {
    font-size: 50px;
    text-align: center;
  }

  .bank-flex {
    display: flex;
    align-items: center;
    img {
      height: auto;
      width: 100px;
      max-width: 100%;
      margin: 20px;
    }
  }
  i {
    &.fa-copy {
      &:hover {
        cursor: pointer;
        color: $primary;
      }
    }
  }
  .svg {
    width: 80px;
    min-width: 80px;
    min-height: 80px;
    margin: auto;
  }

  .qrcode-preview {
    width: 160px;
    height: 160px;
    border: 1px dashed white;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 160px;
      height: auto;
    }

    img {
      width: 160px;
      height: auto;
    }
  }

  &.kbank {
    background: linear-gradient(
      19deg,
      rgb(15, 92, 44) 0%,
      rgb(116, 207, 138) 100%
    );

    .svg {
      background-image: url(~@/assets/logo/kbank.svg);
    }
  }

  &.scb {
    background: linear-gradient(19deg, rgb(39, 0, 82) 0%, rgb(92, 0, 138) 100%);

    .svg {
      background-image: url(~@/assets/logo/scb.svg);
      background-repeat: no-repeat;
    }
  }

  &.ktb {
    background: linear-gradient(rgb(0, 137, 247) 25%, rgb(0, 163, 228) 100%);

    .svg {
      background-image: url(~@/assets/logo/ktb.svg);
      background-repeat: no-repeat;
    }
  }

  &.bay {
    background: linear-gradient(#ecb430 25%, #f5c658 100%);

    .svg {
      background-image: url(~@/assets/logo/bay.svg);
      background-repeat: no-repeat;
    }
  }

  &.gsb {
    background: linear-gradient(#d82e8a 25%, #d82e8a 100%);

    .svg {
      background-image: url(~@/assets/logo/gsb.svg);
      background-repeat: no-repeat;
    }
  }

  &.bcel {
    background: #b81f21;
  }

  &.paymentww {
    background: #2a58f5;
  }

  &.paymentpaywell {
    background: #3695af;
  }

  &.paymentpayonex {
    background: #fe54af;
  }
}

.bank-name-th {
  font-size: 18px;
  font-weight: 700;
}
.bank-name-en {
  font-size: 12px;
}

.display-flex {
  display: flex;
  width: 100%;
}

.my-account {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  .note {
    color: $danger;
    font-weight: 700;
    margin-bottom: 20px;

    span {
      font-weight: 400;
      font-size: 12px;
    }
  }
  .bank-detail {
    .bank-name-th {
      font-size: 18px;
      font-weight: 700;
    }
    .bank-name-en {
      font-size: 12px;
    }
  }
}

.word-wrap {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.condition {
  color: $danger;
  font-size: 12px;
}

.profile-noted {
  color: white;
  font-size: 16px;
}
.profile-edit {
  display: flex;

  input {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>
